enum PackageAdditionalServiceEnum {
  PriceCalculation,
  AwaitingPayment,
  Paid,
  Shipped,
}

export default PackageAdditionalServiceEnum
